/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{IANAZone as n,Zone as t}from"luxon";class o{}function e(n){return n instanceof t?n===o.instance:"unknown"===n?.toString().toLowerCase()}function r(n){return e(n)?o.instance:n}o.instance=new n("Etc/UTC");export{o as UnknownTimeZone,e as isUnknownTimeZone,r as substituteUnknownTimezone};
